import { useMutation } from '@tanstack/react-query';

import {
  CreateCreditReversalPayload,
  CreateCreditReversalResponse,
  createCreditReversal,
} from '~/services/PaymentsService';

const CREDIT_REVERSAL_BASE_KEY = 'creditReversals' as const;

export const creditReversalKeys = {
  all: [CREDIT_REVERSAL_BASE_KEY] as const,
  lists: () => [...creditReversalKeys.all, 'list'] as const,
  details: () => [...creditReversalKeys.all, 'detail'] as const,
  detail: (id: string) => [...creditReversalKeys.details(), id] as const,
  mutations: {
    // Static tuple avoids a self-reference at object-literal construction time
    create: [CREDIT_REVERSAL_BASE_KEY, 'create'] as const,
  },
};

export function useCreateCreditReversal() {
  return useMutation<CreateCreditReversalResponse, Error, CreateCreditReversalPayload>({
    mutationKey: creditReversalKeys.mutations.create,
    mutationFn: (payload: CreateCreditReversalPayload) => createCreditReversal(payload),
  });
}
